// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__2z9zr","tab":"ProcedureTabs_tab__1oJYp"};